@if (show) {
  <div class="update-dialog-overlay">
    <div class="update-dialog">
      <div class="update-dialog-header">
        <h3>Atualização Disponível</h3>
      </div>
      <div class="update-dialog-body">
        <p>Uma nova versão da aplicação está disponível!</p>
        <p>Deseja atualizar agora para obter as melhorias mais recentes?</p>
        <div class="countdown-info">
          <i class="fas fa-clock"></i>
          <span>A aplicação será atualizada automaticamente em <strong>{{ countdown }}</strong> segundos</span>
        </div>
      </div>
      <div class="update-dialog-footer">
        <button class="btn btn-secondary" (click)="onCancel()">
          Mais Tarde
        </button>
        <button class="btn btn-primary" (click)="onConfirm()">
          <i class="fas fa-check"></i>
          Atualizar Agora
        </button>
      </div>
    </div>
  </div>
}
